import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../../layouts/ComposablePageLayout';
import ArticlePageQuery from './ArticlePage.gql';
import pageData from './ArticlePage.json';
import notFoundPageData from './ArticlePageNotFound.json';

const ArticlePage = () => {
  const { render } = useComposablePage();
  const content = render(pageData, notFoundPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: ArticlePageQuery,
  isFound: (data) => data.brand.article,
})(ArticlePage);
